export default __webpack_public_path__ + "static/media/5.992a8190.png";